import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { Controller, type FieldValues, type Path, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { type ElementTracking, useElementTracking } from "../../../analytics/analytics";

interface Props<TFieldValues extends FieldValues> {
  name: Path<TFieldValues>;
}

export const CeAlign = <TFieldValues extends FieldValues>({
  name,
  analyticsCategory,
}: Props<TFieldValues> & ElementTracking): React.JSX.Element => {
  const { control } = useFormContext<TFieldValues>();
  const { t } = useTranslation();
  const analyticsPropsLeft = useElementTracking(analyticsCategory, name, "align", "left");
  const analyticsPropsCenter = useElementTracking(analyticsCategory, name, "align", "center");
  const analyticsPropsRight = useElementTracking(analyticsCategory, name, "align", "right");
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl>
          <FormLabel>{t("Align")}</FormLabel>
          <RadioGroup row {...field}>
            <FormControlLabel
              value="left"
              control={<Radio />}
              label={t("Left")}
              {...analyticsPropsLeft}
            />
            <FormControlLabel
              value="center"
              control={<Radio />}
              label={t("Center")}
              {...analyticsPropsCenter}
            />
            <FormControlLabel
              value="right"
              control={<Radio />}
              label={t("Right")}
              {...analyticsPropsRight}
            />
          </RadioGroup>
          {error && (
            <Typography variant="caption" color="error">
              {error.message}
            </Typography>
          )}
        </FormControl>
      )}
    />
  );
};
